import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {httpEditProjectDisabilityProfiles, HttpEditProjectDisabilityProfilesOptions} from '../http/projects.http'

export const useEditProjectDisabilityProfiles = ({
    urlParams,
    options
}: {
    urlParams: HttpEditProjectDisabilityProfilesOptions['urlParams']
    options?: UseMutationOptions<unknown, unknown, HttpEditProjectDisabilityProfilesOptions['payload']>
}) => {
    return useMutation({
        ...options,
        mutationFn: payload => httpEditProjectDisabilityProfiles({urlParams, payload}),
        // The caller optimistically patches the project cache via setQueriesData, but progressStatus is
        // backend-computed: invalidate to refetch so the header badge reflects the new completion state.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
}
